/**
 * Typed binding for GET /admin/stats (PR #5h).
 *
 * `get()` requires `admin.audit.view`.
 */

import { AdminStatsSchema, type AdminStats } from '../schemas/stats.js';
import type { RequestOptions, Transport } from './transport.js';

export interface StatsClient {
  get(options?: RequestOptions): Promise<AdminStats>;
}

export const createStatsClient = (transport: Transport): StatsClient => ({
  get: (options) => transport.get('/admin/stats', AdminStatsSchema, options),
});
